import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QueryBuilder, ColumnsModel, RuleModel } from '@syncfusion/ej2-angular-querybuilder';
import { Browser } from '@syncfusion/ej2-base';
import { element } from 'protractor';
import { Category } from 'src/app/_models';
import { BulkUpdateService } from 'src/app/_services/bulkupdate.service';
import { CategoryService } from 'src/app/_services/category.service';

@Component({
  selector: 'app-bulk-operations',
  templateUrl: './bulk-operations.component.html',
  styleUrls: ['./bulk-operations.component.scss']
})

export class BulkOperationsComponent implements OnInit {
  openUpdateMetadata: boolean = false;

  constructor() { }

  ngOnInit() {
    this.updateMetadata()
  }

  updateMetadata() {
    this.openUpdateMetadata = true
  }

}
